/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Anytime_App_StoreInputs */

const en_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel anytime via your app store`)
};

const ar_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإلغاء في أي وقت عبر متجر التطبيقات`)
};

const de_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jederzeit über Ihren App Store kündigen`)
};

const es_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancela en cualquier momento a través de tu tienda de apps`)
};

const fr_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulez à tout moment via votre boutique d'application`)
};

const it_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla in qualsiasi momento tramite il tuo app store`)
};

const ja_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリストアからいつでもキャンセル可能`)
};

const ko_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앱 스토어에서 언제든지 취소할 수 있어요`)
};

const pt_br_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancele quando quiser na loja de aplicativos`)
};

const ru_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отписывайтесь в любое время через магазин приложений`)
};

const th_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกได้ตลอดเวลาผ่านทาง app store ของคุณ`)
};

const tr_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulama mağazan üzerinden dilediğin zaman iptal et`)
};

const zh_cn_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可随时在应用商城取消`)
};

const zh_tw_cancel_anytime_app_store = /** @type {(inputs: Cancel_Anytime_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可隨時在應用商城取消`)
};

/**
* | output |
* | --- |
* | "Cancel anytime via your app store" |
*
* @param {Cancel_Anytime_App_StoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cancel_anytime_app_store = /** @type {((inputs?: Cancel_Anytime_App_StoreInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Anytime_App_StoreInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_anytime_app_store(inputs)
	if (locale === "ar") return ar_cancel_anytime_app_store(inputs)
	if (locale === "de") return de_cancel_anytime_app_store(inputs)
	if (locale === "es") return es_cancel_anytime_app_store(inputs)
	if (locale === "fr") return fr_cancel_anytime_app_store(inputs)
	if (locale === "it") return it_cancel_anytime_app_store(inputs)
	if (locale === "ja") return ja_cancel_anytime_app_store(inputs)
	if (locale === "ko") return ko_cancel_anytime_app_store(inputs)
	if (locale === "pt_br") return pt_br_cancel_anytime_app_store(inputs)
	if (locale === "ru") return ru_cancel_anytime_app_store(inputs)
	if (locale === "th") return th_cancel_anytime_app_store(inputs)
	if (locale === "tr") return tr_cancel_anytime_app_store(inputs)
	if (locale === "zh_cn") return zh_cn_cancel_anytime_app_store(inputs)
	return zh_tw_cancel_anytime_app_store(inputs)
});